<script>
    export let title = 'allibee';
</script>

<svelte:head>
    <title>{title}</title>
</svelte:head>
